import { AppState } from '../models/state/appState';
import { AvailableTelsState } from '../models/state/availableTelsState';

/**
 * Selects the available tels.
 * @param state The aplication state.
 */
export function selectAvailableTels(state: AppState): AvailableTelsState {
  return state.availableTels;
}
